// extracted by mini-css-extract-plugin
export var root = "Dropdown-module--root--xITDm";
export var selectContainer = "Dropdown-module--selectContainer--ECxnb";
export var label = "Dropdown-module--label--tNr5y";
export var caretContainer = "Dropdown-module--caretContainer--7HZb4";